<div class="page-title-area item-bg1 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="index.html">Главная</a></li>
                <li>Error</li>
            </ul>
            <h2>Error 404</h2>
        </div>
    </div>
</div>

<div class="error-404-area">
    <div class="container">
        <div class="notfound">
            <div class="notfound-bg">
                <div></div>
                <div></div>
                <div></div>
            </div>
            <h1>Oops!</h1>
            <h3>Error 404 : Страница не найдена</h3>
            <p>Страница, которую вы ищете, могла быть удалена из-за изменения ее названия или временно недоступна.</p>
            <a routerLink="/" class="default-btn"><i class='bx bx-home-circle icon-arrow before'></i><span class="label">Назад на главную</span><i class="bx bx-home-circle icon-arrow after"></i></a>
        </div>
    </div>
</div>
